import React from "react";
import { H3, SystemMessage, Text } from "@shoptet/ui";
import { Trans, useTranslation } from "react-i18next";
import { Accordion } from "../elements/Accordion";
import { AudienceSignals } from "../elements/AdvancedSetup/AudienceSignals";
import { BiddingScheme } from "../elements/AdvancedSetup/BiddingScheme";
import { Deactivate } from "../elements/AdvancedSetup/Deactivate";
import { ExcludeProducts } from "../elements/AdvancedSetup/ExcludeProducts";
import { ExtendedConversions } from "../elements/AdvancedSetup/ExtendedConversions";
import { PrimaryColor } from "../elements/AdvancedSetup/PrimaryColor";
import { CategorySelectionWrapper } from "../elements/CategoriesSelection";
import { ReturnCredits } from "../elements/Credits/ReturnCredits";
import { SmallLoader } from "../elements/SmallLoader";
import { SuggestionInputForm } from "../elements/SuggestionInputForm";
import { TabNavigation } from "../elements/TabNavigation";
import { useLastSuggestionRequestQuery, useOrganizationStateQuery } from "../graphql/generated/graphql";

export const Settings = () => {
  const { t } = useTranslation("translation", { keyPrefix: "Settings Page" });
  const { t: tSuggestions } = useTranslation("translation", { keyPrefix: "Wizard Suggestion Generator Page" });
  const { data: lastSuggestionRequestData, loading: lastSuggestionRequestLoading } = useLastSuggestionRequestQuery({
    fetchPolicy: "network-only",
  });
  const { data: organizationStateData } = useOrganizationStateQuery({
    variables: {
      dateTo: new Date().toISOString().split("T")[0],
    },
  });

  const hasOptimizations = (organizationStateData?.organization?.campaignOptimizations?.length ?? 0) > 0;

  return (
    <div>
      <h1>{t("Headline")}</h1>
      <TabNavigation />
      <Accordion header={t("Input data Headline")}>
        {lastSuggestionRequestLoading ? (
          <SmallLoader />
        ) : (
          <>
            <SystemMessage description={tSuggestions("WarningBox")} level="alert" />
            <SuggestionInputForm
              buttonText={tSuggestions("Update")}
              category={lastSuggestionRequestData?.organization?.category}
              showExample={false}
              defaultUserInput={
                lastSuggestionRequestData?.organization?.lastSuggestionRequestsShortHeadline?.[0]?.userInput
              }
            />
          </>
        )}
        <div style={{ marginTop: "32px" }}>
          <div style={{ marginBottom: "16px" }}>
            <H3>{t("Primary Color headline")}</H3>
          </div>
          <div style={{ marginBottom: "16px" }}>
            <Text>{t("Primary Color description")}</Text>
          </div>
          <PrimaryColor />
        </div>
      </Accordion>
      <br />
      <br />
      <Accordion header={tSuggestions("Selected categories headline")}>
        <SystemMessage description={tSuggestions("Advanced options info box")} level="alert" />
        <p>{tSuggestions("Selected categories description")}</p>
        <CategorySelectionWrapper />
      </Accordion>
      <br />
      <br />
      <Accordion header={t("Advanced Settings Headline")}>
        <SystemMessage
          level="alert"
          description={
            <Text>
              <Trans components={{ b: <b /> }} i18nKey="Advanced Settings WarningBox" t={t} />
            </Text>
          }
        />
        {!hasOptimizations && (
          <>
            <h3>{t("BiddingScheme")}</h3>
            <p>{t("BiddingScheme Text")}</p>
            <BiddingScheme />
          </>
        )}
        <h3>{t("AudienceSignals")}</h3>
        <p>{t("AudienceSignals Text")}</p>
        <AudienceSignals />
        <h3>{t("ExtendedConversions")}</h3>
        <p>{t("ExtendedConversions Text")}</p>
        <ExtendedConversions />
        <h3>{t("ExcludeProducts")}</h3>
        <ExcludeProducts />
      </Accordion>
      <br />
      <br />
      <Accordion header={t("Return Credits Headline")}>
        <ReturnCredits />
      </Accordion>
      <br />
      <br />
      <Deactivate />
    </div>
  );
};
